export default (entityData = []) => (_, { id }) =>
    entityData.find(d => d.id == id);



// WEBPACK FOOTER //
// ./src/resolver/Query/single.js